import { IEndUse } from '@/Core.Service.Domain/Sites/EndUses/types/EndUse.ts';
const apiVersion = 'v1';

const getEndUsesLatestReadings = async (siteId: string): Promise<IEndUse[]> => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/enduses/latest-readings/sites/${siteId}`
    );

    const { data } = response.data;
    const filteredData = data.filter((endUse: IEndUse) => {
      return endUse.equipment;
    });

    return filteredData.length > 0 ? filteredData : [];
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getEndUsesLatestReadings,
};
